export const serverUrl = 'https://bluefoxnodejs.herokuapp.com';



// WEBPACK FOOTER //
// ./src/config.js